/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { Select as AntdSelect } from 'antd';
import clsx from 'clsx';

import s from './styles.module.less';

// TODO: do something with clear icon when showArrow === true. It overlaps loader
// TODO: add focus color
const Select = React.forwardRef(({ loadMore, loadMoreOffset = 50, onPopupScroll, className, ...props }, ref) => {
  const handlePopupScroll = React.useCallback(
    (event) => {
      if (loadMore) {
        const { target } = event;
        if (target.scrollTop + target.offsetHeight === target.scrollHeight) {
          loadMore();
        }
      }

      if (onPopupScroll) onPopupScroll(event);
    },
    [loadMore, onPopupScroll],
  );

  return (
    <AntdSelect
      ref={ref}
      className={clsx(s.custom, className)}
      // Style differently dropdown for searchable select
      dropdownClassName={clsx(props.showSearch && s.searchableDropdown, props.dropdownClassName)}
      {...props}
      onPopupScroll={handlePopupScroll}
      getPopupContainer={(trigger) => trigger.parentNode}
    />
  );
});

const EntitySelect = React.forwardRef(
  (
    {
      onChange,
      onSelect,
      value,
      idKey = 'id',
      formatLabel = ({ name }) => name,
      formatValue = (data) => ({ value: data[idKey], label: formatLabel(data) }),
      children, // omitted
      entities,
      ...props
    },
    ref,
  ) => {
    const handleChange = (item, option) => {
      // eslint-disable-next-line no-unused-expressions
      onChange?.(item && option.entity);
    };

    const handleSelect = (item, option) => {
      // eslint-disable-next-line no-unused-expressions
      onSelect?.(item && option.entity);
    };

    return (
      <Select
        ref={ref}
        onChange={handleChange}
        onSelect={handleSelect}
        value={value && formatValue(value)}
        {...props}
        labelInValue
      >
        {entities.map((entity) => {
          const id = entity[idKey];
          const label = formatLabel(entity);

          return (
            <Select.Option key={id} value={id} entity={entity}>
              {label}
            </Select.Option>
          );
        })}
      </Select>
    );
  },
);

Select.Entities = EntitySelect;
Select.Option = AntdSelect.Option;
Select.OptGroup = AntdSelect.OptGroup;

export default Select;
